export function getPageViewsResp() {
  return {
    countPageViews: 433,
    pageViews: [
      {
        count: 148,
        url: "/dashboard/events/details",
      },
      {
        count: 100,
        url: "/dashboard/targets",
      },
      {
        count: 95,
        url: "/dashboard/events",
      },
      {
        count: 90,
        url: "/dashboard/overview",
      },
      {
        count: 21,
        url: "/dashboard/impact",
      },
    ],
  };
}
